module.exports = __webpack_public_path__ + "imgs/video-play-image.jpg";